import { NudgeProps } from '../jdsnudge/logic';

interface NudgeContainerProps {
  nudges: NudgeProps[];
  onShow?: (id: string) => void;
  onClose?: (id: string) => void;
}

export const withLogic =
  (
    Component: React.ComponentType<NudgeContainerProps>
  ): React.FC<NudgeContainerProps> =>
  (props: NudgeContainerProps) => {
    return (
      <Component
        {...{
          ...props,
          activeNudges: props.nudges.map((n) => ({
            ...n,
            prefix: n.prefix || n.icon
          }))
        }}
      />
    );
  };
